<div class="hr-line-dashed"></div>
<div class="pos-relative">

  <div class="form-group">
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">Referral</label>
      <div class="value">
        <input class="form-control" [value]="getBalanceSum('REFERRAL') | number: '1.1-2'" disabled>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">In. SMS</label>
      <div class="value">
        <input class="form-control" [value]="getBalanceSum('MT_SMS') | number: '1.1-2'" disabled>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">Out. SMS</label>
      <div class="value">
        <input class="form-control" [value]="getBalanceSum('MO_SMS') | number: '1.1-2'" disabled>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">CLI</label>
      <div class="value">
        <input class="form-control" [value]="getBalanceSum('CALL') | number: '1.1-2'" disabled>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25">Bonus</label>
      <div class="value">
        <input class="form-control" [value]="getBalanceSum('BONUS') | number: '1.1-2'" disabled>
      </div>
    </div>
    <div class="d-flex justify-content-start align-items-center gap-10 my-15">
      <label class="w-25 fw-bold">RESULT</label>
      <div class="d-flex justify-content-end w-75 my-10">
        <span class="fw-bold">{{getBalanceSum() | number: '1.1-2'}}</span>
      </div>
    </div>
  </div>
</div>
<style>
  .value {
    flex: 1;
    input {
      text-align: right;
    }
  }
</style>
